import { render, staticRenderFns } from "./show_bad_check_images.vue?vue&type=template&id=5f73d141&scoped=true&"
import script from "./show_bad_check_images.vue?vue&type=script&lang=js&"
export * from "./show_bad_check_images.vue?vue&type=script&lang=js&"
import style0 from "./show_bad_check_images.vue?vue&type=style&index=0&id=5f73d141&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f73d141",
  null
  
)

export default component.exports